import React from 'react'

import Icon from 'components/Icon'

import StyledImageUpload from './StyledImageUpload'

const ImageUpload = ({ onClick }) => (
  <StyledImageUpload onClick={onClick}>
    <Icon name="plus-circle" />
  </StyledImageUpload>
)

export default ImageUpload
